import { FunctionComponent } from 'react';

import Logo from 'components/layout/Logo';

import StyledComponent from './styles';
import { Props } from './types';

export const ContentBlocksContactInfoTile: FunctionComponent<Props> = ({ translations }) => {
    return (
        <StyledComponent className="content-blocks-contact-info-tile">
            <div className='contact-info-header-wrapper'>
                <p className='contact-info-headline'>
                    {translations.contactInfoHeader}
                </p>
            </div>

            <hr className='divider'></hr>

            <div className='contact-info-details-wrapper'>
                <p>
                    {translations.contactInfoPhone}
                </p>
                <p>
                    {translations.contactInfoEmail}
                </p>
            </div>

            <div className='logo-wrapper'>
                <Logo
                    width={40}
                    height={35}
                />
                <h3 className="logo-title">
                    {translations.contactInfoSiteName}
                </h3>
            </div>

            <div className='contact-info-details-wrapper'>
                <p>
                    {translations.contactInfoAddress}
                </p>
                <p>
                    {translations.contactInfoTaxId}
                </p>
            </div>

            <hr className='divider'></hr>
        </StyledComponent >
    );
};

export default ContentBlocksContactInfoTile;
